import { render, staticRenderFns } from "./SegmentTrimInput.vue?vue&type=template&id=215cc13c&scoped=true"
import script from "./SegmentTrimInput.vue?vue&type=script&lang=js"
export * from "./SegmentTrimInput.vue?vue&type=script&lang=js"
import style0 from "./SegmentTrimInput.vue?vue&type=style&index=0&id=215cc13c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215cc13c",
  null
  
)

export default component.exports